import { useMemo } from 'react'
import { Trans, useLingui } from '@lingui/react/macro'
import { GraphQL } from '@guestgoodie/graphql'

import Button from '@/components/ui/Button'
import ConfirmDialog from '@/components/ui/ConfirmDialog'
import { useSync } from '../hooks/useSync'
import { usePms } from '../hooks/usePms'

export function SyncButton({ type }: { type: GraphQL.SyncableObject }) {
  const { t } = useLingui()
  const { sync, loading } = useSync(type)
  const pms = usePms()

  const typeTranslation = useMemo(() => {
    if (type === GraphQL.SyncableObject.Rooms) return t`Re-Sync Rooms with PMS`
    if (type === GraphQL.SyncableObject.Stays) return t`Re-Sync Stays with PMS`
  }, [t, type])

  const isSyncing = useMemo(() => {
    return pms?.syncing?.includes(type)
  }, [pms?.syncing, type])

  if (!pms?.isConnected) return null
  if (!typeTranslation) return null

  return (
    <ConfirmDialog
      asChild
      title={typeTranslation}
      message={t`This should barely ever be needed, only do this if you are missing data or their is data that should have been deleted.`}
      onConfirm={sync}
    >
      <Button variant="outline" loading={loading || isSyncing}>
        <Trans>Re-Sync with PMS</Trans>
      </Button>
    </ConfirmDialog>
  )
}
